import React, { Component } from 'react';
import { every } from 'lodash';
import { routes, TYPES } from 'constants/config';
import { Icon } from 'ui';
import request from 'utils/request_ajax';
import TriggerField from './TriggerField';
import UpdateButton from './UpdateButton';

class TriggerBuilder extends Component {
  constructor(params) {
    super(params);
    const {
      assignee_id: assigneeId,
      assignee_type: assigneeType,
      triggerable_id: triggerableId,
      triggerable_type: triggerableType,
      assignable_id: assignableId,
      assignable_type: assignableType,
      due_in_days: dueInDays,
      enabled,
    } = this.props.trigger;

    this.state = {
      loading: false,
      triggerParams: {
        assigneeId,
        assigneeType,
        triggerableId,
        triggerableType,
        assignableId,
        assignableType,
        dueInDays,
        enabled,
      },
    };
  }

  handleSubmit = params => {
    this.setState({ loading: true });
    const { trigger } = this.props;

    params = {
      ...params,
      trigger: this.state.triggerParams,
    };

    request
      .putJSON(routes.TRIGGER(trigger.id), params)
      .then(() => {
        window.location.assign(routes.TRIGGERS.INDEX);
      })
      .fail(res => {
        /** @todo 'errors' is set in state but we're not actually handling them */
        // eslint-disable-next-line react/no-unused-state
        this.setState({ errors: res.errors });
      });
  };

  get confirmGroupTriggerUpdate() {
    const { trigger, groupTriggerUnassignedUserCount } = this.props;
    const { triggerParams } = this.state;

    return every([
      this.isGroupTriggerable,
      groupTriggerUnassignedUserCount > 0,
      !trigger.enabled,
      triggerParams.enabled,
    ]);
  }

  get isGroupTriggerable() {
    const { trigger } = this.props;
    return trigger.triggerable_type === TYPES.GROUP;
  }

  handleChange = ({ target }, params = null) => {
    params = params || { [target.name]: target.value };

    if (target.name === 'enabled') {
      // Parse string value to boolean
      params.enabled = JSON.parse(target.value);
    }

    this.setState(state => ({
      triggerParams: {
        ...state.triggerParams,
        ...params,
      },
    }));
  };

  render() {
    const { trigger, groupTriggerUnassignedUserCount } = this.props;
    const { loading, triggerParams } = this.state;

    return (
      <>
        <div className="Index-header">
          <h1 className="Index-title">{t('triggers.edit')}</h1>
        </div>
        <div className="Triggers-container">
          <div className="Trigger">
            <TriggerField
              name="assignee"
              defaultValue={trigger.assignee_name}
              label={t('triggers.labels.assignee')}
              placeholder={t('triggers.assignee_placeholder')}
              url={routes.ASSIGNABLES.ASSIGNEES}
              onSelect={this.handleChange}
            />
            {this.isGroupTriggerable && (
              <TriggerField
                name="triggerable"
                defaultValue={trigger.triggerable_title}
                label={t('triggers.labels.group_add')}
                placeholder={t('groups.group_name')}
                url={routes.ASSIGNABLES.GROUP_ASSIGNEES}
                onSelect={this.handleChange}
              />
            )}
            {!this.isGroupTriggerable && (
              <TriggerField
                name="triggerable"
                defaultValue={trigger.triggerable_title}
                label={t('triggers.labels.completable')}
                placeholder={t('common.assignable')}
                suggestionNameKey="title"
                url={routes.ASSIGNABLES.CONTENT}
                onSelect={this.handleChange}
              />
            )}
            <TriggerField
              name="assignable"
              defaultValue={trigger.assignable_title}
              label={t('triggers.labels.assignable')}
              placeholder={t('common.assignable')}
              suggestionNameKey="title"
              url={routes.ASSIGNABLES.CONTENT}
              onSelect={this.handleChange}
            />
            <section>
              <label htmlFor="dueInDays">
                {t('triggers.due.in')}
                <input
                  type="number"
                  name="dueInDays"
                  step="1"
                  min="0"
                  defaultValue={triggerParams.dueInDays}
                  className="NewInput NewInput--light w-60 m-0-2"
                  onChange={this.handleChange}
                />
                {t('triggers.due.days')}.
              </label>
            </section>
            <section>
              <div className="Select ml-8 d-f ai-c">
                <select
                  name="enabled"
                  className="NewButton"
                  defaultValue={triggerParams.enabled}
                  onChange={this.handleChange}
                >
                  <option value="true">{t('triggers.enabled.true')}</option>
                  <option value="false">{t('triggers.enabled.false')}</option>
                </select>
                <Icon name="select_arrows" className="pos-r" />
              </div>
            </section>
          </div>

          <div className="mt-16">
            <UpdateButton
              unassignedUserCount={groupTriggerUnassignedUserCount}
              confirmGroupTriggerUpdate={this.confirmGroupTriggerUpdate}
              loading={loading}
              onClick={this.handleSubmit}
            />
            <a className="u-linkBtn u-linkBtn--dark ml-16" href="/triggers">
              {t('common.cancel')}
            </a>
          </div>
        </div>
      </>
    );
  }
}

export default TriggerBuilder;
